/**
 * Типы для отправки уведомлений (писем по шаблону)
 */

/** Шаблон письма с ИНН клиента */
export const ADD_TAX_ID_TEMPLATE_ID = 'add_tax_id';

export interface SendNotificationRequest {
    /** Идентификатор шаблона письма */
    template_id: string;
    /** Переменные шаблона: имя переменной -> значение (для `add_tax_id`: CompanyName, TaxID) */
    vars: Record<string, string>;
}
